import React from "react";
// prettier-ignore
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../shadcn/dropdownMenu";

interface DropdownProps {
  trigger: React.ReactNode;
  label?: string;
  items: (
    | { label: string; icon?: React.ElementType; onClick: () => void } // E.g.{ label: "Profile", icon: Person, onClick: () => functionName() }
    | { separator: true } // Separator item
  )[]; 
}


export const Dropdown: React.FC<DropdownProps> = ({ trigger, label, items }) => {
  return (
    <DropdownMenu >
      <DropdownMenuTrigger asChild>
        {trigger}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {label && <DropdownMenuLabel>{label}</DropdownMenuLabel>}
        {label && <DropdownMenuSeparator />}

        {items.map((item, index) => {
          if ("separator" in item) {
            return <DropdownMenuSeparator key={`separator-${index}`} />;
          }
          const isDelete = item.label.toLowerCase().includes("delete") || item.label.toLowerCase().includes("remove");
          return (
            <DropdownMenuItem
              key={index}
              onClick={item.onClick}
              className={`flex items-center text-sm gap-2 ${isDelete ? "text-danger hover:bg-dangerLight" : ""}`}
            >
              {item.icon && <item.icon size={21} className={isDelete ? "text-red-500" : "text-customBlack"} />}
              {item.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
